import React from 'react';

const fitOptions = [
  { label: 'Slim Fit', value: 'slim' },
  { label: 'Regular Fit', value: 'regular' },
  { label: 'Relaxed Fit', value: 'relaxed' }
];

const StepFitPreference = ({ data, setData, onNext, onPrev }) => {
  const handleSelect = (value) => {
    setData(prev => ({
      ...prev,
      fitPreference: value
    }));
  };

  const handleSkip = () => {
    setData(prev => ({
      ...prev,
      fitPreference: null
    }));
    onNext();
  };

  return (
    <main className="rbt-main-wrapper">
      <div className="container custom-checkout-container">
        <div className="row">
          <div className="">
            <div className="fit-select-container">
              <h3 className="fit-select-title">How do you prefer the fit of your clothing?</h3>

              {fitOptions.map(option => (
                <button
                  key={option.value}
                  className={`fit-select-btn ${data.fitPreference === option.value ? 'active' : ''}`}
                  onClick={() => handleSelect(option.value)}
                >
                  {option.label}
                </button>
              ))}

              <button className="fit-select-skip mt-3" onClick={handleSkip}>
                I'm not sure, skip this question
              </button>

              <div className="fit-select-nav mt-4">
                <button className="fit-select-prev-btn" onClick={onPrev}>Prev</button>
                <button
                  className="fit-select-next-btn"
                  onClick={onNext}
                  disabled={!data.fitPreference}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default StepFitPreference;
